import { render, staticRenderFns } from "./TabsNavigation.vue?vue&type=template&id=bd9d97da&scoped=true&"
import script from "./TabsNavigation.vue?vue&type=script&lang=js&"
export * from "./TabsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TabsNavigation.vue?vue&type=style&index=0&id=bd9d97da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9d97da",
  null
  
)

export default component.exports